export const identityInitialState = {
  identity: null,
}

export const IDENTITY_ACTIONS = {
  SET_IDENTITY: 'SET_IDENTITY',
}

export const identityActions = {
  [IDENTITY_ACTIONS.SET_IDENTITY]: (_, { identity }) => {
    return { identity }
  },
}
